// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"260":"f2ada6ae388f9286","2787":"4ec3af9977a7ef19","4500":"8ee27133e4f377ff","9679":"42cca2e273952e6c"}[chunkId] + ".css";
};